export default __webpack_public_path__ + "static/media/pyposition_109.6ba6370e.png";